@if (loading()) {
  <div class="eventq-site-overview-details__skeleton" aria-hidden="true">
    <div class="eventq-site-overview-details__skeleton-heading"></div>
    <div class="eventq-site-overview-details__skeleton-card">
      <div class="eventq-site-overview-details__skeleton-block eventq-site-overview-details__skeleton-block--label"></div>
      <div class="eventq-site-overview-details__skeleton-block eventq-site-overview-details__skeleton-block--title"></div>
      <div class="eventq-site-overview-details__skeleton-block eventq-site-overview-details__skeleton-block--address"></div>
      <div class="eventq-site-overview-details__skeleton-fields">
        @for (row of [1, 2, 3, 4, 5, 6]; track row) {
          <div class="eventq-site-overview-details__skeleton-field">
            <div class="eventq-site-overview-details__skeleton-block eventq-site-overview-details__skeleton-block--field-label"></div>
            <div class="eventq-site-overview-details__skeleton-block eventq-site-overview-details__skeleton-block--field-value"></div>
          </div>
        }
      </div>
    </div>
  </div>
} @else if (hasContent()) {
  <div class="eventq-site-overview-details">
    <h2 class="eventq-site-overview-details__section-heading">{{ sectionHeading() }}</h2>

    <div class="eventq-site-overview-details__card">
      <div class="eventq-site-overview-details__general">
        <p class="eventq-site-overview-details__general-label">{{ generalLabel() }}</p>
        <p class="eventq-site-overview-details__site-name">{{ siteName() }}</p>
        <p class="eventq-site-overview-details__address">{{ address() }}</p>
      </div>

      <div class="eventq-site-overview-details__fields">
        <div class="eventq-site-overview-details__fields-grid">
          @for (field of fields(); track field.id) {
            <div class="eventq-site-overview-details__field">
              <p class="eventq-site-overview-details__field-label">{{ field.label }}</p>
              <p class="eventq-site-overview-details__field-value">{{ field.value }}</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
